import React from "react";

type SnackbarProps = {
  open: boolean;
  message: string;
  onClose: () => void;
};

const snackbarStyle: React.CSSProperties = {
  position: "fixed",
  left: 24,
  bottom: 24,
  minWidth: 240,
  background: "#323232",
  color: "#fff",
  padding: "12px 24px",
  borderRadius: 6,
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  zIndex: 9999,
  transition: "opacity 0.3s",
  opacity: 1,
  fontSize: 16,
};

export const Snackbar: React.FC<SnackbarProps> = ({ open, message, onClose }) => {
  React.useEffect(() => {
    if (!open) return;
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div style={snackbarStyle} onClick={onClose}>
      {message}
    </div>
  );
};